import { configureStore } from "@reduxjs/toolkit";

import hamburgerReducer from "./slice/hamburgerSlice";
import eventsReducer from "./slice/eventsSlice";

const store = configureStore({
    reducer: {
        hamburger: hamburgerReducer,
        events: eventsReducer,
    }
})

export default store;